<template>
  <div class="flex flex-col form-content p-5">
    <div class="flex w-full mb-6">
      <div class="flex flex-col w-1/2 pr-1">
        <form-item label='Search'>
          <Input
            v-model="filter.q"
            placeholder="Search specific query"
          />
        </form-item>
      </div>
      <div class="flex flex-col w-1/2 pl-1">
        <form-item label='Categories'>
          <Select
            v-model="filter.genre"
            empty-label="All Categories"
            :data="listGenre"
          />
        </form-item>
      </div>
    </div>
    <div class="flex w-full mb-6">
      <div class="flex flex-col w-1/2 pr-1">
        <form-item label='Tags'>
          <el-select
            class="w-full"
            multiple
            filterable
            remote
            default-first-option
            reserve-keyword
            size="large"
            placeholder="Add a tag to filter songs"
            :remote-method="searchTags"
            v-model="tagsValue"
            :loading="loadingTags"
            ref="tagSelect"
            @change="changeTag"
          >
            <el-option
              v-for="item in tagsOption"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </form-item>
      </div>
      <div class="flex flex-col w-1/2 pl-1">
        <form-item label='Language'>
          <el-select
            class="w-full"
            multiple
            filterable
            default-first-option
            reserve-keyword
            size="large"
            placeholder="Add a language to filter songs"
            v-model="langValue"
            ref="langSelect"
            @change="changeLang"
          >
            <el-option
              v-for="item in langOption"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </form-item>
      </div>
    </div>
    <div class="flex w-full mb-3">
      <button @click="search" class="text-sm w-full focus:outline-none px-4 py-2 rounded font-bold cursor-pointer
                          hover:bg-blue-100 hover:text-blue-700
                          text-blue-100 bg-blue-700
                            border duration-200 ease-in-out
                          border-blue-600 transition">Search</button>
    </div>
    <data-tables-server ref="tableSong" class="song-management" :data="listSong" :total="totalSong" :pagination-props="{ background: true,pageSizes: [10] }" @query-change="onChangeTable" >
      <el-table-column v-for="column in tableSongColumn" :prop="column.prop" :label="column.label" :key="column.prop" sortable="custom" >
      </el-table-column>
      <el-table-column label="Song" width="250px" >
        <template slot-scope="scope">
          <audio controls :src="scope.row.preview_file_data" :id="'audioPlayer'+scope.row.id" class="audio-player" style="width: 240px;" controlsList="nodownload" type="audio/mp3" preload="none" >
            Audio tag not supported
          </audio>
        </template>
      </el-table-column>
      <el-table-column  label="Actions" align="right" width="150px" >
        <template slot-scope="scope">
          <div class="static inline-block text-left container-action">
            <VueCustomTooltip :label="!scope.row.added?'Add':'Remove'" :position="'is-left'">
              <button v-if="!scope.row.added" @click="addSongTo(scope.row,true)" class="p-2 rounded bg-blue-700 text-blue-100 hover:bg-blue-100 hover:text-blue-700 border duration-200 ease-in-out
                          border-blue-600 transition focus:outline-none" >
                <font-awesome-icon :icon="['fa', 'plus']" /> Add
              </button>
              <button v-if="scope.row.added" @click="addSongTo(scope.row,false)" class="p-2 rounded bg-blue-100 text-blue-700 hover:bg-blue-700 hover:text-blue-100 border duration-200 ease-in-out
                          border-blue-600 transition focus:outline-none" >
                <font-awesome-icon  :icon="['fa', 'check']" /> Remove
              </button>
            </VueCustomTooltip>
          </div>
        </template>
      </el-table-column>
    </data-tables-server>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import { FormItem, Input, TextArea, Button, TextError, Select } from '@/components/Layout/Form';
import helpersMixin from '../../mixins/helpers.mixins';

const API_URL = process.env.API_URL;

export default {
  name: 'SearchSong',
  mixins: [helpersMixin],
  props: {
    toggleReset: {
      type: Boolean,
      default: () => false,
    },
    takenSong: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      addSong: [],
      listSong: [],
      totalSong: 0,

      listGenre: [],

      tagsValue: [],
      tagsOption: [],
      loadingTags: false,

      langValue: [],
      langOption: [],
      loadingLang: false,

      filter: {
        page: 1,
        per_page: 10,
        q: '',
        genre: null,
        tag: '',
        language: '',
      },

      tableSongColumn: [
        {
          prop: 'title',
          label: 'Song Name',
        },
        {
          prop: 'album',
          label: 'Album',
        },
        {
          prop: 'artist',
          label: 'Artist',
        },
      ],
      dataListGenre: [],
    };
  },
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
    ...mapGetters('PlaylistModule', ['listSongSearch']),
    ...mapGetters('AuthModule', ['tokenType', 'accessToken']),
  },
  watch: {
    toggleReset: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetState();
        }
      },
    },
    listSongSearch: {
      immediate: true,
      deep: true,
      async handler(val) {
        if (this.listSongSearch.data != null && this.listSongSearch.data != undefined) {
          if (this.listSongSearch.length !== 0) {
            this.totalSong = this.listSongSearch.total;
            if (typeof (this.listSongSearch.data) === 'undefined') return;
            this.listSong = await Promise.all(this.listSongSearch.data.map(async (song) => {
              const preview_file_data = await this.getMusicFile(song.file);
              const added = this.isExist(song.id);
              return Object.assign(
                {},
                song,
                {
                  preview_file_data,
                  added,
                },
              );
            }));
          }
        }
      },
    },
  },
  async mounted() {
    this.totalSong = 0;
    this.listSong = [];
    this.langOption = this.getLanguages();
    const genreSong = await this.requestGetGenreSong();
    this.listGenre = genreSong.map(v => ({
      value: v.id,
      label: v.name,
    }));
  },
  methods: {
    ...mapActions('SongModule', ['requestGetTags']),
    ...mapActions('PlaylistModule', ['requestGetGenreSong', 'requestGetListSong']),
    resetState() {
      this.addSong = [...this.takenSong];
      this.listSong = [];
      this.totalSong = 0;

      this.tagsValue = [];
      this.tagsOption = [];
      this.loadingTags = false;

      this.langValue = [];
      this.loadingLang = false;

      this.filter = {
        page: 1,
        per_page: 10,
        q: '',
        genre: null,
        tag: '',
        language: '',
      };
    },
    async searchTags(query) {
      if (query !== '') {
        this.loadingTags = true;
        const tags = await this.requestGetTags({ q: query });
        this.loadingTags = false;
        this.tagsOption = tags.map(item => ({ value: item.name, label: item.name }));
      } else {
        this.tagsOption = [];
      }
    },
    async search() {
      this.filter.page = 1;
      this.filter.tag = this.tagsValue.length > 0 ? this.tagsValue.join(',') : '';
      this.filter.language = this.langValue.length > 0 ? this.langValue.join(',') : '';
      await this.requestGetListSong(this.filter);
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'ascending' || typeof (queryInfo.sort.order) === 'undefined' ? 'desc' : 'asc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortby = 'id';
      sortorder = 'asc';
      this.filter = Object.assign(this.filter, { page });
      // await this.requestListSong(this.filter);
      await this.requestGetListSong(this.filter);
    },
    async getMusicFile(file) {
      const hostname = file.indexOf('//') > -1 ? `https://${file.split('/')[2]}` : file.split('/')[0];
      const fileAudio = await axios({
        method: 'get',
        url: file.replace(hostname, API_URL),
        headers: {
          Authorization: `${this.tokenType} ${this.accessToken}`,
        },
      });
      return fileAudio.data;
    },
    isExist(id) {
      return this.addSong.findIndex(song => song.id === id) !== -1;
    },
    addSongTo(row, status) {
      row.added = status;
      if (status) {
        const newRow = { ...row };
        this.addSong.push(newRow);
      } else {
        this.$emit('on-remove-song', row.id);
        const index = this.addSong.findIndex(song => song.id === row.id);
        this.addSong.splice(index, 1);
      }
    },
    submit() {
      this.$emit('on-submit-song', this.addSong);
    },
    changeLang(event) {
      this.$refs.langSelect.blur();
    },
    changeTag(event) {
      this.$refs.tagSelect.blur();
    },
  },
  components: { FormItem, Input, TextArea, Button, TextError, Select },
};
</script>

<style scoped>
.form-content{
  min-width: 900px;
}
@media screen and (max-width: 500px){
  .form-content {
    min-width: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Playlist/SearchSong.vue